import { reducerWithInitialState } from 'typescript-fsa-reducers/dist'
import * as actions from './actions'
import * as apiActions from '../api/actions'
import { FormStoreState } from './types'

export interface StoreState {
	readonly forms: FormStoreState
}

const INITIAL_STATE: StoreState = {
	forms: {}
}

export const reducer = reducerWithInitialState(INITIAL_STATE)
	.case(
		apiActions.fetchForm.started,
		(state, payload): StoreState => {
			if (payload.isPreCaching) {
				return state
			}

			return {
				...state,
				forms: {
					...state.forms,
					[payload.id]: { loading: true },
				},
			}
		},
	)
	.case(
		apiActions.fetchForm.done,
		(state, payload): StoreState => {
			if (payload.params.isPreCaching) {
				return state
			}

			return {
				...state,
				forms: {
					...state.forms,
					[payload.params.id]: {
						item: payload.result,
						version: payload.params.version,
						loading: false,
					}
				},
			}
		},
	)
	.case(
		apiActions.fetchForm.failed,
		(state, payload): StoreState => {
			if (payload.params.isPreCaching) {
				return state
			}

			return {
				...state,
				forms: {
					...state.forms,
					[payload.params.id]: { error: payload.error, loading: false },
				},
			}
		},
	)
	.case(
		actions.loadedFormFromDisk,
		(state, payload): StoreState => {
			return {
				...state,
				forms: {
					...state.forms,
					[payload.id]: { item: payload.form, version: payload.version, loading: false },
				},
			}
		},
	)
